// Module
var code = "<div div class=\"oe-selector\" style=\"{{>visibility}}\">\r\n    <terceraLabel text=\"{{label}}\" />\r\n\r\n    <div class=\"oe-selector-right\">\r\n        <terceraInstrumentLookup enabled=\"{{enabled}}\" mayContainTrees=\"true\" selectedItem=\"{{instrument}}\" selectedAccount=\"{{account}}\" />\r\n    </div>\r\n</div>";
// Exports
export default code;